/* eslint-disable */
// AUTO-GENERATED by scripts/gen-config.js from .env.bottlemart.yml — DO NOT EDIT OR COMMIT.
// Typed as a loose bag (matching the prior react-native-ultimate-config default
// export); app/config.ts re-types each field into the curated `config` object.
const config: Record<string, any> = {
  "APP_NAME": "Bottlemart",
  "BUNDLE_ID": "au.com.lmg.bottlemart",
  "BUNDLE_VERSION": 1,
  "MARKETING_VERSION": "3.4.20",
  "WHITE_LABEL_ID": "bottlemart",
  "APP_STORE_ID": "1237960786",
  "BASE_TENANT": "BM",
  "BASE_URL": "https://mw.lmg-bw.au",
  "TILL_GATEWAY": "https://gateway.tillpayments.com/js/integrated/payment.1.3.min.js",
  "HOST_DOMAIN": "bottlemart.com.au",
  "DEFAULT_STORE": "C000182178",
  "DEFAULT_STORE_STATE": "QLD",
  "SUMMER_CASH_GRAB_COMPETITION_NAME": "summer-cash-grab",
  "SUPPORT_EMAIL": "online@bottlemart.com.au",
  "GIFT_CARD_STORE": "bottlemartgiftstore",
  "GIFT_CARDS_PROMOTION_ID": "Bottlemart-gift-card",
  "FF_IS_GIFT_CARDS_ENABLED": true,
  "WEB_HEADER_DISABLED": [
    "MEGA_MENU_GIFTS"
  ],
  "FF_GIFT_CARD_ALL_STORES": false,
  "ONESIGNAL_APP_ID": "078b3424-e370-443f-85db-910de69b24a7",
  "OTEL_ENABLED": true,
  "OTEL_SERVICE_NAME": "frontend-bottlemart",
  "OTEL_SAMPLE_RATE": 1,
  "OTEL_DEBUG": false,
  "USE_API_PROXY": true,
  "SENTRY_DSN": "https://b8167d415374b364ba8b8d41ef3fa710@o4504137358442496.ingest.us.sentry.io/4510655432097792",
  "APPLE_PAY_MERCHANT_NAME": "Bottlemart",
  "APPLE_PAY_MERCHANT_ID": "merchant.com.lmg.production"
};

export default config;
